import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageArchamps: React.FC = () => (
  <LocalSeoPage
    city="Archamps"
    slug="depannage-informatique-archamps"
    metaTitle="Dépannage Informatique Archamps | Technicien PC Local"
    metaDescription="Technicien informatique à Archamps. PC lent, virus, WiFi, Windows bloqué. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur vous pose problème à Archamps ? Notre technicien intervient rapidement à domicile ou à distance. PC lent, virus, panne WiFi ou Windows bloqué — diagnostic 100 % gratuit, devis clair, zéro surprise."
    postalCode="74160"
    nearbyTowns={[
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Collonges-sous-Salève', link: '/depannage-informatique-collonges-sous-saleve' },
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Neydens' },
      { name: 'Présilly' },
      { name: 'Beaumont' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Collonges-sous-Salève', href: '/depannage-informatique-collonges-sous-saleve' },
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageArchamps;
